import { Flex } from "@rebass/grid";
import {
  IContract,
  EContractIndexationStatus,
} from "@rentiohq/shared-frontend/dist/types/contract.types";
import {
  EPropertyMemberTypes,
  IProperty,
} from "@rentiohq/shared-frontend/dist/types/property.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { iHaveRole } from "@rentiohq/shared-frontend/dist/utils/roles.utils";
import {
  Button,
  Card,
  DisplayText,
  ESpacings,
  Icon,
  RentioInternalRenderer,
  Stack,
} from "@rentiohq/web-shared/dist/components";
import { useInternalMode } from "@rentiohq/web-shared/dist/redux/system/system.hooks";
import { IChecklistItem } from "../ChecklistItem";
import * as S from "./IndexationCard.styled";

interface IProps {
  indexationItem: IChecklistItem;
  contract: IContract;
  property: IProperty;
}

export const IndexationCard = ({
  indexationItem,
  contract,
  property,
}: IProps) => {
  const { internalModeEnabled } = useInternalMode();

  const canIndex =
    contract.indexationStatus &&
    [
      EContractIndexationStatus.Ready,
      EContractIndexationStatus.OwnerAsked,
      EContractIndexationStatus.OwnerApproved,
    ].includes(contract.indexationStatus);

  const allowedInInternalMode =
    internalModeEnabled &&
    !iHaveRole(property, EPropertyMemberTypes.IndexationManager);

  return (
    <Card.Section
      boxProps={{
        px: ESpacings.loose,
        py: ESpacings.base,
      }}
    >
      <DisplayText size="extraSmall">
        {getLocalizedText("property.indexation_possible.label")}
      </DisplayText>
      <S.Wrapper onClick={canIndex ? indexationItem?.onClick : undefined}>
        <Flex justifyContent="space-between" alignItems="center">
          <Stack spacing="tight" alignment="center">
            <Icon source="currencyEuroIncrease" />

            {allowedInInternalMode ? (
              <RentioInternalRenderer>
                Indexation is possible, but no indexation role
              </RentioInternalRenderer>
            ) : (
              <S.TaskTitle>
                {getLocalizedText(
                  `property.dashboard.checklist.index_contract.${contract.indexationStatus}.content`.toLowerCase(),
                )}
              </S.TaskTitle>
            )}
          </Stack>
          {canIndex && indexationItem?.onClick && (
            <Button size="small" color="primary">
              {`${getLocalizedText("system.start")} ›`}
            </Button>
          )}
        </Flex>
      </S.Wrapper>
    </Card.Section>
  );
};
